import { combineReducers } from 'redux';

import steps from './steps';
import token from './token';
import account from './account';
import auth from '../auth';
import tags from '../tags';
import users from '../users';
import snackbar from '../snackbar';
import segments from '../segments';

export default combineReducers({
  steps,
  token,
  account,
  auth,
  tags,
  users,
  snackbar,
  segments,
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js